import { getAllLocation } from "./location";
import { getAllStockItems } from "./item";
import { getAllStock } from "./stock";
import { getDefaultHistory } from "./history";
import { getAllReceipts } from "./receipt";
import { getStockReceived } from "./received";
import { getLocationsRequest } from "./locationRequest";
import { getAllLocationReceived } from "./locationReceived";
import { getRequest } from "./request";
import { getRequisitions } from "./requisition";
import { getLocationStock } from "./getLocationStock";
import { locationDefaultHistory } from "./locationDefaultHistory";
import { getLocationItems } from "./locationItems";
import { getLocationReceipts } from "./locationReceipts";
import { getSingleLocationReceipt } from "./singleLocationReceipt";
import { admin_stock_received_yearly_cost } from "./adminReceivedYearlyCost";
import { location_stock_received_yearly_cost } from "./locationReceivedYearlyCost";
import { getAdminForecast } from "./forecast";
import { CurrentPrices } from "./CurrentPrices";

// The data the app keeps in the store, loaded for what the user's role shows:
// head office (Administrator) works on the main store and all locations,
// everyone else on their own branch.

// The main store, issues, deliveries and requests
export const loadAdminData = () => (dispatch) => {
  dispatch(getAllStockItems());
  dispatch(getAllStock());
  dispatch(getDefaultHistory());
  dispatch(getAllReceipts());
  dispatch(getStockReceived());
  dispatch(getLocationsRequest());
  dispatch(admin_stock_received_yearly_cost());
  dispatch(getAdminForecast());
  dispatch(CurrentPrices());
};

// The user's own branch
export const loadBranchData = () => (dispatch) => {
  dispatch(getAllStockItems());
  dispatch(getLocationStock());
  dispatch(locationDefaultHistory());
  dispatch(getLocationItems());
  dispatch(getLocationReceipts());
  dispatch(getSingleLocationReceipt());
  dispatch(location_stock_received_yearly_cost());
  dispatch(CurrentPrices());
};

export const loadStockData = (isAdmin, isApprover) => (dispatch) => {
  dispatch(getAllLocation());
  if (isAdmin || isApprover) dispatch(getRequisitions());
  // issues waiting for this user's branch to confirm
  dispatch(getAllLocationReceived());
  // requests this user's branch has made
  dispatch(getRequest());
  dispatch(isAdmin ? loadAdminData() : loadBranchData());
};
